"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TooltipPopperMixin = void 0;
var _styledComponents = require("styled-components");
var _TriggerButton = require("../../components/TriggerButton/TriggerButton.styles");
/** @class TooltipPopperMixin */
/** @method */
var TooltipPopperMixin = /*#__PURE__*/(0, _styledComponents.css)(["&,&", ",&", ":after{cursor:help;}"], _TriggerButton.StyledTriggerButton, _TriggerButton.StyledTriggerButton);
exports.TooltipPopperMixin = TooltipPopperMixin;